'use client';

import { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { FAQItem } from '@/lib/data';

interface FAQAccordionProps {
  faq: FAQItem[];
}

export default function FAQAccordion({ faq }: FAQAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="space-y-4">
      {faq.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div
            key={index}
            className="bg-cardBg border border-borderDark rounded-lg overflow-hidden transition-colors"
          >
            <button
              onClick={() => toggleAccordion(index)}
              className="w-full flex items-center justify-between p-5 text-start text-sm font-semibold text-foreground hover:text-accent transition-colors focus:outline-none"
            >
              <span>{item.question}</span>
              {isOpen ? (
                <ChevronUp className="h-4 w-4 text-accent" />
              ) : (
                <ChevronDown className="h-4 w-4 text-textSecondary" />
              )}
            </button>
            <div
              className={`overflow-hidden transition-[opacity] duration-200 ease-in-out ${
                isOpen ? 'opacity-100 border-t border-borderDark' : 'opacity-0 pointer-events-none h-0'
              }`}
            >
              <div className="p-5 text-sm text-textSecondary leading-relaxed bg-background">
                {item.answer}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
